module.exports = {
	"config": {
		"linkPrefix": "/SmartContracts",
		"name": "chronobank-smart-contracts",
		"license": "AGPL-3.0",
		"version": "1.1.47",
		"description": "Chronobank Smart Contracts",
		"author": "Mike Fluff <mf@mikefluff.com> (http://mikefluff.com)",
		"buildTime": "2018-04-10T09:40:04.736Z",
		"target": "scripts/doxity",
		"src": "contracts/*",
		"dir": "pages/docs",
		"source": "https://github.com/DigixGlobal/doxity-gatsby-starter-project/archive/a4886b7a7a04c018ac04fed3125d7d4785e74bed.tar.gz",
		"out": "docs",
		"interaction": {}
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "docs",
				"stem": "_template",
				"path": "docs/_template.jsx",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/_template.jsx",
			"templatePath": "/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "AssetDonator.json",
				"ext": "json",
				"name": "AssetDonator",
				"extname": ".json",
				"basename": "AssetDonator.json",
				"dirname": "docs",
				"stem": "AssetDonator",
				"path": "docs/AssetDonator.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/AssetDonator.json",
				"isAbsolute": false
			},
			"requirePath": "docs/AssetDonator.json",
			"path": "/docs/AssetDonator/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "AssetsManager.json",
				"ext": "json",
				"name": "AssetsManager",
				"extname": ".json",
				"basename": "AssetsManager.json",
				"dirname": "docs",
				"stem": "AssetsManager",
				"path": "docs/AssetsManager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/AssetsManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/AssetsManager.json",
			"path": "/docs/AssetsManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "AssetsManagerEmitter.json",
				"ext": "json",
				"name": "AssetsManagerEmitter",
				"extname": ".json",
				"basename": "AssetsManagerEmitter.json",
				"dirname": "docs",
				"stem": "AssetsManagerEmitter",
				"path": "docs/AssetsManagerEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/AssetsManagerEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/AssetsManagerEmitter.json",
			"path": "/docs/AssetsManagerEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "AssetsManagerMock.json",
				"ext": "json",
				"name": "AssetsManagerMock",
				"extname": ".json",
				"basename": "AssetsManagerMock.json",
				"dirname": "docs",
				"stem": "AssetsManagerMock",
				"path": "docs/AssetsManagerMock.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/AssetsManagerMock.json",
				"isAbsolute": false
			},
			"requirePath": "docs/AssetsManagerMock.json",
			"path": "/docs/AssetsManagerMock/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "BaseManager.json",
				"ext": "json",
				"name": "BaseManager",
				"extname": ".json",
				"basename": "BaseManager.json",
				"dirname": "docs",
				"stem": "BaseManager",
				"path": "docs/BaseManager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/BaseManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/BaseManager.json",
			"path": "/docs/BaseManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "BlockLimitedCrowdsale.json",
				"ext": "json",
				"name": "BlockLimitedCrowdsale",
				"extname": ".json",
				"basename": "BlockLimitedCrowdsale.json",
				"dirname": "docs",
				"stem": "BlockLimitedCrowdsale",
				"path": "docs/BlockLimitedCrowdsale.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/BlockLimitedCrowdsale.json",
				"isAbsolute": false
			},
			"requirePath": "docs/BlockLimitedCrowdsale.json",
			"path": "/docs/BlockLimitedCrowdsale/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "BlockLimitedCrowdsaleFactory.json",
				"ext": "json",
				"name": "BlockLimitedCrowdsaleFactory",
				"extname": ".json",
				"basename": "BlockLimitedCrowdsaleFactory.json",
				"dirname": "docs",
				"stem": "BlockLimitedCrowdsaleFactory",
				"path": "docs/BlockLimitedCrowdsaleFactory.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/BlockLimitedCrowdsaleFactory.json",
				"isAbsolute": false
			},
			"requirePath": "docs/BlockLimitedCrowdsaleFactory.json",
			"path": "/docs/BlockLimitedCrowdsaleFactory/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ChronoBankAsset.json",
				"ext": "json",
				"name": "ChronoBankAsset",
				"extname": ".json",
				"basename": "ChronoBankAsset.json",
				"dirname": "docs",
				"stem": "ChronoBankAsset",
				"path": "docs/ChronoBankAsset.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ChronoBankAsset.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ChronoBankAsset.json",
			"path": "/docs/ChronoBankAsset/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ChronoBankAssetFactory.json",
				"ext": "json",
				"name": "ChronoBankAssetFactory",
				"extname": ".json",
				"basename": "ChronoBankAssetFactory.json",
				"dirname": "docs",
				"stem": "ChronoBankAssetFactory",
				"path": "docs/ChronoBankAssetFactory.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ChronoBankAssetFactory.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ChronoBankAssetFactory.json",
			"path": "/docs/ChronoBankAssetFactory/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ChronoBankAssetProxy.json",
				"ext": "json",
				"name": "ChronoBankAssetProxy",
				"extname": ".json",
				"basename": "ChronoBankAssetProxy.json",
				"dirname": "docs",
				"stem": "ChronoBankAssetProxy",
				"path": "docs/ChronoBankAssetProxy.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ChronoBankAssetProxy.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ChronoBankAssetProxy.json",
			"path": "/docs/ChronoBankAssetProxy/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ChronoBankAssetWithFee.json",
				"ext": "json",
				"name": "ChronoBankAssetWithFee",
				"extname": ".json",
				"basename": "ChronoBankAssetWithFee.json",
				"dirname": "docs",
				"stem": "ChronoBankAssetWithFee",
				"path": "docs/ChronoBankAssetWithFee.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ChronoBankAssetWithFee.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ChronoBankAssetWithFee.json",
			"path": "/docs/ChronoBankAssetWithFee/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ChronoBankAssetWithFeeFactory.json",
				"ext": "json",
				"name": "ChronoBankAssetWithFeeFactory",
				"extname": ".json",
				"basename": "ChronoBankAssetWithFeeFactory.json",
				"dirname": "docs",
				"stem": "ChronoBankAssetWithFeeFactory",
				"path": "docs/ChronoBankAssetWithFeeFactory.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ChronoBankAssetWithFeeFactory.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ChronoBankAssetWithFeeFactory.json",
			"path": "/docs/ChronoBankAssetWithFeeFactory/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ChronoBankAssetWithFeeProxy.json",
				"ext": "json",
				"name": "ChronoBankAssetWithFeeProxy",
				"extname": ".json",
				"basename": "ChronoBankAssetWithFeeProxy.json",
				"dirname": "docs",
				"stem": "ChronoBankAssetWithFeeProxy",
				"path": "docs/ChronoBankAssetWithFeeProxy.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ChronoBankAssetWithFeeProxy.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ChronoBankAssetWithFeeProxy.json",
			"path": "/docs/ChronoBankAssetWithFeeProxy/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ChronoBankPlatform.json",
				"ext": "json",
				"name": "ChronoBankPlatform",
				"extname": ".json",
				"basename": "ChronoBankPlatform.json",
				"dirname": "docs",
				"stem": "ChronoBankPlatform",
				"path": "docs/ChronoBankPlatform.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ChronoBankPlatform.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ChronoBankPlatform.json",
			"path": "/docs/ChronoBankPlatform/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ChronoBankPlatformEmitter.json",
				"ext": "json",
				"name": "ChronoBankPlatformEmitter",
				"extname": ".json",
				"basename": "ChronoBankPlatformEmitter.json",
				"dirname": "docs",
				"stem": "ChronoBankPlatformEmitter",
				"path": "docs/ChronoBankPlatformEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ChronoBankPlatformEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ChronoBankPlatformEmitter.json",
			"path": "/docs/ChronoBankPlatformEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ChronoBankPlatformFactory.json",
				"ext": "json",
				"name": "ChronoBankPlatformFactory",
				"extname": ".json",
				"basename": "ChronoBankPlatformFactory.json",
				"dirname": "docs",
				"stem": "ChronoBankPlatformFactory",
				"path": "docs/ChronoBankPlatformFactory.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ChronoBankPlatformFactory.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ChronoBankPlatformFactory.json",
			"path": "/docs/ChronoBankPlatformFactory/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ChronoBankPlatformTestable.json",
				"ext": "json",
				"name": "ChronoBankPlatformTestable",
				"extname": ".json",
				"basename": "ChronoBankPlatformTestable.json",
				"dirname": "docs",
				"stem": "ChronoBankPlatformTestable",
				"path": "docs/ChronoBankPlatformTestable.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ChronoBankPlatformTestable.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ChronoBankPlatformTestable.json",
			"path": "/docs/ChronoBankPlatformTestable/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ChronoBankTokenExtensionFactory.json",
				"ext": "json",
				"name": "ChronoBankTokenExtensionFactory",
				"extname": ".json",
				"basename": "ChronoBankTokenExtensionFactory.json",
				"dirname": "docs",
				"stem": "ChronoBankTokenExtensionFactory",
				"path": "docs/ChronoBankTokenExtensionFactory.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ChronoBankTokenExtensionFactory.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ChronoBankTokenExtensionFactory.json",
			"path": "/docs/ChronoBankTokenExtensionFactory/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ChronoBankWalletFallbackSupporter.json",
				"ext": "json",
				"name": "ChronoBankWalletFallbackSupporter",
				"extname": ".json",
				"basename": "ChronoBankWalletFallbackSupporter.json",
				"dirname": "docs",
				"stem": "ChronoBankWalletFallbackSupporter",
				"path": "docs/ChronoBankWalletFallbackSupporter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ChronoBankWalletFallbackSupporter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ChronoBankWalletFallbackSupporter.json",
			"path": "/docs/ChronoBankWalletFallbackSupporter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Clock.json",
				"ext": "json",
				"name": "Clock",
				"extname": ".json",
				"basename": "Clock.json",
				"dirname": "docs",
				"stem": "Clock",
				"path": "docs/Clock.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/Clock.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Clock.json",
			"path": "/docs/Clock/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ContractsManager.json",
				"ext": "json",
				"name": "ContractsManager",
				"extname": ".json",
				"basename": "ContractsManager.json",
				"dirname": "docs",
				"stem": "ContractsManager",
				"path": "docs/ContractsManager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ContractsManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ContractsManager.json",
			"path": "/docs/ContractsManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "CrowdsaleManager.json",
				"ext": "json",
				"name": "CrowdsaleManager",
				"extname": ".json",
				"basename": "CrowdsaleManager.json",
				"dirname": "docs",
				"stem": "CrowdsaleManager",
				"path": "docs/CrowdsaleManager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/CrowdsaleManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/CrowdsaleManager.json",
			"path": "/docs/CrowdsaleManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "CrowdsaleManagerEmitter.json",
				"ext": "json",
				"name": "CrowdsaleManagerEmitter",
				"extname": ".json",
				"basename": "CrowdsaleManagerEmitter.json",
				"dirname": "docs",
				"stem": "CrowdsaleManagerEmitter",
				"path": "docs/CrowdsaleManagerEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/CrowdsaleManagerEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/CrowdsaleManagerEmitter.json",
			"path": "/docs/CrowdsaleManagerEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "CryptocomparePriceTicker.json",
				"ext": "json",
				"name": "CryptocomparePriceTicker",
				"extname": ".json",
				"basename": "CryptocomparePriceTicker.json",
				"dirname": "docs",
				"stem": "CryptocomparePriceTicker",
				"path": "docs/CryptocomparePriceTicker.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/CryptocomparePriceTicker.json",
				"isAbsolute": false
			},
			"requirePath": "docs/CryptocomparePriceTicker.json",
			"path": "/docs/CryptocomparePriceTicker/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Deposits.json",
				"ext": "json",
				"name": "Deposits",
				"extname": ".json",
				"basename": "Deposits.json",
				"dirname": "docs",
				"stem": "Deposits",
				"path": "docs/Deposits.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/Deposits.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Deposits.json",
			"path": "/docs/Deposits/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "DepositsDeprecated.json",
				"ext": "json",
				"name": "DepositsDeprecated",
				"extname": ".json",
				"basename": "DepositsDeprecated.json",
				"dirname": "docs",
				"stem": "DepositsDeprecated",
				"path": "docs/DepositsDeprecated.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/DepositsDeprecated.json",
				"isAbsolute": false
			},
			"requirePath": "docs/DepositsDeprecated.json",
			"path": "/docs/DepositsDeprecated/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ERC20DepositStorage.json",
				"ext": "json",
				"name": "ERC20DepositStorage",
				"extname": ".json",
				"basename": "ERC20DepositStorage.json",
				"dirname": "docs",
				"stem": "ERC20DepositStorage",
				"path": "docs/ERC20DepositStorage.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ERC20DepositStorage.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ERC20DepositStorage.json",
			"path": "/docs/ERC20DepositStorage/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ERC20Manager.json",
				"ext": "json",
				"name": "ERC20Manager",
				"extname": ".json",
				"basename": "ERC20Manager.json",
				"dirname": "docs",
				"stem": "ERC20Manager",
				"path": "docs/ERC20Manager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ERC20Manager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ERC20Manager.json",
			"path": "/docs/ERC20Manager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ERC20ManagerEmitter.json",
				"ext": "json",
				"name": "ERC20ManagerEmitter",
				"extname": ".json",
				"basename": "ERC20ManagerEmitter.json",
				"dirname": "docs",
				"stem": "ERC20ManagerEmitter",
				"path": "docs/ERC20ManagerEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ERC20ManagerEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ERC20ManagerEmitter.json",
			"path": "/docs/ERC20ManagerEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Exchange.json",
				"ext": "json",
				"name": "Exchange",
				"extname": ".json",
				"basename": "Exchange.json",
				"dirname": "docs",
				"stem": "Exchange",
				"path": "docs/Exchange.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/Exchange.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Exchange.json",
			"path": "/docs/Exchange/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ExchangeFactory.json",
				"ext": "json",
				"name": "ExchangeFactory",
				"extname": ".json",
				"basename": "ExchangeFactory.json",
				"dirname": "docs",
				"stem": "ExchangeFactory",
				"path": "docs/ExchangeFactory.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ExchangeFactory.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ExchangeFactory.json",
			"path": "/docs/ExchangeFactory/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ExchangeManager.json",
				"ext": "json",
				"name": "ExchangeManager",
				"extname": ".json",
				"basename": "ExchangeManager.json",
				"dirname": "docs",
				"stem": "ExchangeManager",
				"path": "docs/ExchangeManager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ExchangeManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ExchangeManager.json",
			"path": "/docs/ExchangeManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ExchangeManagerEmitter.json",
				"ext": "json",
				"name": "ExchangeManagerEmitter",
				"extname": ".json",
				"basename": "ExchangeManagerEmitter.json",
				"dirname": "docs",
				"stem": "ExchangeManagerEmitter",
				"path": "docs/ExchangeManagerEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ExchangeManagerEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ExchangeManagerEmitter.json",
			"path": "/docs/ExchangeManagerEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "FakeCoin.json",
				"ext": "json",
				"name": "FakeCoin",
				"extname": ".json",
				"basename": "FakeCoin.json",
				"dirname": "docs",
				"stem": "FakeCoin",
				"path": "docs/FakeCoin.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/FakeCoin.json",
				"isAbsolute": false
			},
			"requirePath": "docs/FakeCoin.json",
			"path": "/docs/FakeCoin/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "FakeCoin2.json",
				"ext": "json",
				"name": "FakeCoin2",
				"extname": ".json",
				"basename": "FakeCoin2.json",
				"dirname": "docs",
				"stem": "FakeCoin2",
				"path": "docs/FakeCoin2.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/FakeCoin2.json",
				"isAbsolute": false
			},
			"requirePath": "docs/FakeCoin2.json",
			"path": "/docs/FakeCoin2/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "FakeCoin3.json",
				"ext": "json",
				"name": "FakeCoin3",
				"extname": ".json",
				"basename": "FakeCoin3.json",
				"dirname": "docs",
				"stem": "FakeCoin3",
				"path": "docs/FakeCoin3.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/FakeCoin3.json",
				"isAbsolute": false
			},
			"requirePath": "docs/FakeCoin3.json",
			"path": "/docs/FakeCoin3/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "FakePriceTicker.json",
				"ext": "json",
				"name": "FakePriceTicker",
				"extname": ".json",
				"basename": "FakePriceTicker.json",
				"dirname": "docs",
				"stem": "FakePriceTicker",
				"path": "docs/FakePriceTicker.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/FakePriceTicker.json",
				"isAbsolute": false
			},
			"requirePath": "docs/FakePriceTicker.json",
			"path": "/docs/FakePriceTicker/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "FakePriceTickerManager.json",
				"ext": "json",
				"name": "FakePriceTickerManager",
				"extname": ".json",
				"basename": "FakePriceTickerManager.json",
				"dirname": "docs",
				"stem": "FakePriceTickerManager",
				"path": "docs/FakePriceTickerManager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/FakePriceTickerManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/FakePriceTickerManager.json",
			"path": "/docs/FakePriceTickerManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "FeatureFeeManager.json",
				"ext": "json",
				"name": "FeatureFeeManager",
				"extname": ".json",
				"basename": "FeatureFeeManager.json",
				"dirname": "docs",
				"stem": "FeatureFeeManager",
				"path": "docs/FeatureFeeManager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/FeatureFeeManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/FeatureFeeManager.json",
			"path": "/docs/FeatureFeeManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "KrakenPriceTicker.json",
				"ext": "json",
				"name": "KrakenPriceTicker",
				"extname": ".json",
				"basename": "KrakenPriceTicker.json",
				"dirname": "docs",
				"stem": "KrakenPriceTicker",
				"path": "docs/KrakenPriceTicker.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/KrakenPriceTicker.json",
				"isAbsolute": false
			},
			"requirePath": "docs/KrakenPriceTicker.json",
			"path": "/docs/KrakenPriceTicker/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "LHT.json",
				"ext": "json",
				"name": "LHT",
				"extname": ".json",
				"basename": "LHT.json",
				"dirname": "docs",
				"stem": "LHT",
				"path": "docs/LHT.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/LHT.json",
				"isAbsolute": false
			},
			"requirePath": "docs/LHT.json",
			"path": "/docs/LHT/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "LOCManager.json",
				"ext": "json",
				"name": "LOCManager",
				"extname": ".json",
				"basename": "LOCManager.json",
				"dirname": "docs",
				"stem": "LOCManager",
				"path": "docs/LOCManager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/LOCManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/LOCManager.json",
			"path": "/docs/LOCManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "LOCManagerEmitter.json",
				"ext": "json",
				"name": "LOCManagerEmitter",
				"extname": ".json",
				"basename": "LOCManagerEmitter.json",
				"dirname": "docs",
				"stem": "LOCManagerEmitter",
				"path": "docs/LOCManagerEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/LOCManagerEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/LOCManagerEmitter.json",
			"path": "/docs/LOCManagerEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "LOCWallet.json",
				"ext": "json",
				"name": "LOCWallet",
				"extname": ".json",
				"basename": "LOCWallet.json",
				"dirname": "docs",
				"stem": "LOCWallet",
				"path": "docs/LOCWallet.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/LOCWallet.json",
				"isAbsolute": false
			},
			"requirePath": "docs/LOCWallet.json",
			"path": "/docs/LOCWallet/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Managed.json",
				"ext": "json",
				"name": "Managed",
				"extname": ".json",
				"basename": "Managed.json",
				"dirname": "docs",
				"stem": "Managed",
				"path": "docs/Managed.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/Managed.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Managed.json",
			"path": "/docs/Managed/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ManagerMock.json",
				"ext": "json",
				"name": "ManagerMock",
				"extname": ".json",
				"basename": "ManagerMock.json",
				"dirname": "docs",
				"stem": "ManagerMock",
				"path": "docs/ManagerMock.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/ManagerMock.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ManagerMock.json",
			"path": "/docs/ManagerMock/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Migrations.json",
				"ext": "json",
				"name": "Migrations",
				"extname": ".json",
				"basename": "Migrations.json",
				"dirname": "docs",
				"stem": "Migrations",
				"path": "docs/Migrations.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/Migrations.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Migrations.json",
			"path": "/docs/Migrations/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "MultiEventsHistory.json",
				"ext": "json",
				"name": "MultiEventsHistory",
				"extname": ".json",
				"basename": "MultiEventsHistory.json",
				"dirname": "docs",
				"stem": "MultiEventsHistory",
				"path": "docs/MultiEventsHistory.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/MultiEventsHistory.json",
				"isAbsolute": false
			},
			"requirePath": "docs/MultiEventsHistory.json",
			"path": "/docs/MultiEventsHistory/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "MultiEventsHistoryAdapter.json",
				"ext": "json",
				"name": "MultiEventsHistoryAdapter",
				"extname": ".json",
				"basename": "MultiEventsHistoryAdapter.json",
				"dirname": "docs",
				"stem": "MultiEventsHistoryAdapter",
				"path": "docs/MultiEventsHistoryAdapter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/MultiEventsHistoryAdapter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/MultiEventsHistoryAdapter.json",
			"path": "/docs/MultiEventsHistoryAdapter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Object.json",
				"ext": "json",
				"name": "Object",
				"extname": ".json",
				"basename": "Object.json",
				"dirname": "docs",
				"stem": "Object",
				"path": "docs/Object.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/Object.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Object.json",
			"path": "/docs/Object/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Once.json",
				"ext": "json",
				"name": "Once",
				"extname": ".json",
				"basename": "Once.json",
				"dirname": "docs",
				"stem": "Once",
				"path": "docs/Once.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/Once.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Once.json",
			"path": "/docs/Once/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Owned.json",
				"ext": "json",
				"name": "Owned",
				"extname": ".json",
				"basename": "Owned.json",
				"dirname": "docs",
				"stem": "Owned",
				"path": "docs/Owned.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/Owned.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Owned.json",
			"path": "/docs/Owned/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "OwnedContract.json",
				"ext": "json",
				"name": "OwnedContract",
				"extname": ".json",
				"basename": "OwnedContract.json",
				"dirname": "docs",
				"stem": "OwnedContract",
				"path": "docs/OwnedContract.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/OwnedContract.json",
				"isAbsolute": false
			},
			"requirePath": "docs/OwnedContract.json",
			"path": "/docs/OwnedContract/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "PendingManager.json",
				"ext": "json",
				"name": "PendingManager",
				"extname": ".json",
				"basename": "PendingManager.json",
				"dirname": "docs",
				"stem": "PendingManager",
				"path": "docs/PendingManager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/PendingManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/PendingManager.json",
			"path": "/docs/PendingManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "PendingManagerEmitter.json",
				"ext": "json",
				"name": "PendingManagerEmitter",
				"extname": ".json",
				"basename": "PendingManagerEmitter.json",
				"dirname": "docs",
				"stem": "PendingManagerEmitter",
				"path": "docs/PendingManagerEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/PendingManagerEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/PendingManagerEmitter.json",
			"path": "/docs/PendingManagerEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "PlatformsManager.json",
				"ext": "json",
				"name": "PlatformsManager",
				"extname": ".json",
				"basename": "PlatformsManager.json",
				"dirname": "docs",
				"stem": "PlatformsManager",
				"path": "docs/PlatformsManager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/PlatformsManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/PlatformsManager.json",
			"path": "/docs/PlatformsManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "PlatformsManagerDammyDeprecated.json",
				"ext": "json",
				"name": "PlatformsManagerDammyDeprecated",
				"extname": ".json",
				"basename": "PlatformsManagerDammyDeprecated.json",
				"dirname": "docs",
				"stem": "PlatformsManagerDammyDeprecated",
				"path": "docs/PlatformsManagerDammyDeprecated.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/PlatformsManagerDammyDeprecated.json",
				"isAbsolute": false
			},
			"requirePath": "docs/PlatformsManagerDammyDeprecated.json",
			"path": "/docs/PlatformsManagerDammyDeprecated/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "PlatformsManagerEmitter.json",
				"ext": "json",
				"name": "PlatformsManagerEmitter",
				"extname": ".json",
				"basename": "PlatformsManagerEmitter.json",
				"dirname": "docs",
				"stem": "PlatformsManagerEmitter",
				"path": "docs/PlatformsManagerEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/PlatformsManagerEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/PlatformsManagerEmitter.json",
			"path": "/docs/PlatformsManagerEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "PlatformTokenExtensionGatewayManager.json",
				"ext": "json",
				"name": "PlatformTokenExtensionGatewayManager",
				"extname": ".json",
				"basename": "PlatformTokenExtensionGatewayManager.json",
				"dirname": "docs",
				"stem": "PlatformTokenExtensionGatewayManager",
				"path": "docs/PlatformTokenExtensionGatewayManager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/PlatformTokenExtensionGatewayManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/PlatformTokenExtensionGatewayManager.json",
			"path": "/docs/PlatformTokenExtensionGatewayManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "PlatformTokenExtensionGatewayManagerEmitter.json",
				"ext": "json",
				"name": "PlatformTokenExtensionGatewayManagerEmitter",
				"extname": ".json",
				"basename": "PlatformTokenExtensionGatewayManagerEmitter.json",
				"dirname": "docs",
				"stem": "PlatformTokenExtensionGatewayManagerEmitter",
				"path": "docs/PlatformTokenExtensionGatewayManagerEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/PlatformTokenExtensionGatewayManagerEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/PlatformTokenExtensionGatewayManagerEmitter.json",
			"path": "/docs/PlatformTokenExtensionGatewayManagerEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "PollBackend.json",
				"ext": "json",
				"name": "PollBackend",
				"extname": ".json",
				"basename": "PollBackend.json",
				"dirname": "docs",
				"stem": "PollBackend",
				"path": "docs/PollBackend.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/PollBackend.json",
				"isAbsolute": false
			},
			"requirePath": "docs/PollBackend.json",
			"path": "/docs/PollBackend/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "PollEmitter.json",
				"ext": "json",
				"name": "PollEmitter",
				"extname": ".json",
				"basename": "PollEmitter.json",
				"dirname": "docs",
				"stem": "PollEmitter",
				"path": "docs/PollEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/PollEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/PollEmitter.json",
			"path": "/docs/PollEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "PollFactory.json",
				"ext": "json",
				"name": "PollFactory",
				"extname": ".json",
				"basename": "PollFactory.json",
				"dirname": "docs",
				"stem": "PollFactory",
				"path": "docs/PollFactory.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/PollFactory.json",
				"isAbsolute": false
			},
			"requirePath": "docs/PollFactory.json",
			"path": "/docs/PollFactory/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "PollRouter.json",
				"ext": "json",
				"name": "PollRouter",
				"extname": ".json",
				"basename": "PollRouter.json",
				"dirname": "docs",
				"stem": "PollRouter",
				"path": "docs/PollRouter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/PollRouter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/PollRouter.json",
			"path": "/docs/PollRouter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Rewards.json",
				"ext": "json",
				"name": "Rewards",
				"extname": ".json",
				"basename": "Rewards.json",
				"dirname": "docs",
				"stem": "Rewards",
				"path": "docs/Rewards.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/Rewards.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Rewards.json",
			"path": "/docs/Rewards/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "RewardsEmitter.json",
				"ext": "json",
				"name": "RewardsEmitter",
				"extname": ".json",
				"basename": "RewardsEmitter.json",
				"dirname": "docs",
				"stem": "RewardsEmitter",
				"path": "docs/RewardsEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/RewardsEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/RewardsEmitter.json",
			"path": "/docs/RewardsEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "RewardsWallet.json",
				"ext": "json",
				"name": "RewardsWallet",
				"extname": ".json",
				"basename": "RewardsWallet.json",
				"dirname": "docs",
				"stem": "RewardsWallet",
				"path": "docs/RewardsWallet.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/RewardsWallet.json",
				"isAbsolute": false
			},
			"requirePath": "docs/RewardsWallet.json",
			"path": "/docs/RewardsWallet/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Rooted.json",
				"ext": "json",
				"name": "Rooted",
				"extname": ".json",
				"basename": "Rooted.json",
				"dirname": "docs",
				"stem": "Rooted",
				"path": "docs/Rooted.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/Rooted.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Rooted.json",
			"path": "/docs/Rooted/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "SafeMath.json",
				"ext": "json",
				"name": "SafeMath",
				"extname": ".json",
				"basename": "SafeMath.json",
				"dirname": "docs",
				"stem": "SafeMath",
				"path": "docs/SafeMath.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/SafeMath.json",
				"isAbsolute": false
			},
			"requirePath": "docs/SafeMath.json",
			"path": "/docs/SafeMath/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "SetStorageInterface_v_1_1.json",
				"ext": "json",
				"name": "SetStorageInterface_v_1_1",
				"extname": ".json",
				"basename": "SetStorageInterface_v_1_1.json",
				"dirname": "docs",
				"stem": "SetStorageInterface_v_1_1",
				"path": "docs/SetStorageInterface_v_1_1.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/SetStorageInterface_v_1_1.json",
				"isAbsolute": false
			},
			"requirePath": "docs/SetStorageInterface_v_1_1.json",
			"path": "/docs/SetStorageInterface_v_1_1/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Storage.json",
				"ext": "json",
				"name": "Storage",
				"extname": ".json",
				"basename": "Storage.json",
				"dirname": "docs",
				"stem": "Storage",
				"path": "docs/Storage.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/Storage.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Storage.json",
			"path": "/docs/Storage/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "StorageAdapter.json",
				"ext": "json",
				"name": "StorageAdapter",
				"extname": ".json",
				"basename": "StorageAdapter.json",
				"dirname": "docs",
				"stem": "StorageAdapter",
				"path": "docs/StorageAdapter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/StorageAdapter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/StorageAdapter.json",
			"path": "/docs/StorageAdapter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "StorageInterface.json",
				"ext": "json",
				"name": "StorageInterface",
				"extname": ".json",
				"basename": "StorageInterface.json",
				"dirname": "docs",
				"stem": "StorageInterface",
				"path": "docs/StorageInterface.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/StorageInterface.json",
				"isAbsolute": false
			},
			"requirePath": "docs/StorageInterface.json",
			"path": "/docs/StorageInterface/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "StorageManager.json",
				"ext": "json",
				"name": "StorageManager",
				"extname": ".json",
				"basename": "StorageManager.json",
				"dirname": "docs",
				"stem": "StorageManager",
				"path": "docs/StorageManager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/StorageManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/StorageManager.json",
			"path": "/docs/StorageManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "StringsLib.json",
				"ext": "json",
				"name": "StringsLib",
				"extname": ".json",
				"basename": "StringsLib.json",
				"dirname": "docs",
				"stem": "StringsLib",
				"path": "docs/StringsLib.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/StringsLib.json",
				"isAbsolute": false
			},
			"requirePath": "docs/StringsLib.json",
			"path": "/docs/StringsLib/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Stub.json",
				"ext": "json",
				"name": "Stub",
				"extname": ".json",
				"basename": "Stub.json",
				"dirname": "docs",
				"stem": "Stub",
				"path": "docs/Stub.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/Stub.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Stub.json",
			"path": "/docs/Stub/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TIME.json",
				"ext": "json",
				"name": "TIME",
				"extname": ".json",
				"basename": "TIME.json",
				"dirname": "docs",
				"stem": "TIME",
				"path": "docs/TIME.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/TIME.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TIME.json",
			"path": "/docs/TIME/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TimeAsset.json",
				"ext": "json",
				"name": "TimeAsset",
				"extname": ".json",
				"basename": "TimeAsset.json",
				"dirname": "docs",
				"stem": "TimeAsset",
				"path": "docs/TimeAsset.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/TimeAsset.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TimeAsset.json",
			"path": "/docs/TimeAsset/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TimeAssetProxy.json",
				"ext": "json",
				"name": "TimeAssetProxy",
				"extname": ".json",
				"basename": "TimeAssetProxy.json",
				"dirname": "docs",
				"stem": "TimeAssetProxy",
				"path": "docs/TimeAssetProxy.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/TimeAssetProxy.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TimeAssetProxy.json",
			"path": "/docs/TimeAssetProxy/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TimeHolder.json",
				"ext": "json",
				"name": "TimeHolder",
				"extname": ".json",
				"basename": "TimeHolder.json",
				"dirname": "docs",
				"stem": "TimeHolder",
				"path": "docs/TimeHolder.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/TimeHolder.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TimeHolder.json",
			"path": "/docs/TimeHolder/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TimeHolderDammyWallet.json",
				"ext": "json",
				"name": "TimeHolderDammyWallet",
				"extname": ".json",
				"basename": "TimeHolderDammyWallet.json",
				"dirname": "docs",
				"stem": "TimeHolderDammyWallet",
				"path": "docs/TimeHolderDammyWallet.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/TimeHolderDammyWallet.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TimeHolderDammyWallet.json",
			"path": "/docs/TimeHolderDammyWallet/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TimeHolderDeprecated.json",
				"ext": "json",
				"name": "TimeHolderDeprecated",
				"extname": ".json",
				"basename": "TimeHolderDeprecated.json",
				"dirname": "docs",
				"stem": "TimeHolderDeprecated",
				"path": "docs/TimeHolderDeprecated.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/TimeHolderDeprecated.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TimeHolderDeprecated.json",
			"path": "/docs/TimeHolderDeprecated/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TimeHolderEmitter.json",
				"ext": "json",
				"name": "TimeHolderEmitter",
				"extname": ".json",
				"basename": "TimeHolderEmitter.json",
				"dirname": "docs",
				"stem": "TimeHolderEmitter",
				"path": "docs/TimeHolderEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/TimeHolderEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TimeHolderEmitter.json",
			"path": "/docs/TimeHolderEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TimeHolderWallet.json",
				"ext": "json",
				"name": "TimeHolderWallet",
				"extname": ".json",
				"basename": "TimeHolderWallet.json",
				"dirname": "docs",
				"stem": "TimeHolderWallet",
				"path": "docs/TimeHolderWallet.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/TimeHolderWallet.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TimeHolderWallet.json",
			"path": "/docs/TimeHolderWallet/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TimeLimitedCrowdsale.json",
				"ext": "json",
				"name": "TimeLimitedCrowdsale",
				"extname": ".json",
				"basename": "TimeLimitedCrowdsale.json",
				"dirname": "docs",
				"stem": "TimeLimitedCrowdsale",
				"path": "docs/TimeLimitedCrowdsale.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/TimeLimitedCrowdsale.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TimeLimitedCrowdsale.json",
			"path": "/docs/TimeLimitedCrowdsale/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TimeLimitedCrowdsaleFactory.json",
				"ext": "json",
				"name": "TimeLimitedCrowdsaleFactory",
				"extname": ".json",
				"basename": "TimeLimitedCrowdsaleFactory.json",
				"dirname": "docs",
				"stem": "TimeLimitedCrowdsaleFactory",
				"path": "docs/TimeLimitedCrowdsaleFactory.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/TimeLimitedCrowdsaleFactory.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TimeLimitedCrowdsaleFactory.json",
			"path": "/docs/TimeLimitedCrowdsaleFactory/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TimePlatform.json",
				"ext": "json",
				"name": "TimePlatform",
				"extname": ".json",
				"basename": "TimePlatform.json",
				"dirname": "docs",
				"stem": "TimePlatform",
				"path": "docs/TimePlatform.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/TimePlatform.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TimePlatform.json",
			"path": "/docs/TimePlatform/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TimePlatformEmitter.json",
				"ext": "json",
				"name": "TimePlatformEmitter",
				"extname": ".json",
				"basename": "TimePlatformEmitter.json",
				"dirname": "docs",
				"stem": "TimePlatformEmitter",
				"path": "docs/TimePlatformEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/TimePlatformEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TimePlatformEmitter.json",
			"path": "/docs/TimePlatformEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TokenExtensionRouter.json",
				"ext": "json",
				"name": "TokenExtensionRouter",
				"extname": ".json",
				"basename": "TokenExtensionRouter.json",
				"dirname": "docs",
				"stem": "TokenExtensionRouter",
				"path": "docs/TokenExtensionRouter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/TokenExtensionRouter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TokenExtensionRouter.json",
			"path": "/docs/TokenExtensionRouter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TokenFactory.json",
				"ext": "json",
				"name": "TokenFactory",
				"extname": ".json",
				"basename": "TokenFactory.json",
				"dirname": "docs",
				"stem": "TokenFactory",
				"path": "docs/TokenFactory.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/TokenFactory.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TokenFactory.json",
			"path": "/docs/TokenFactory/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "UserManager.json",
				"ext": "json",
				"name": "UserManager",
				"extname": ".json",
				"basename": "UserManager.json",
				"dirname": "docs",
				"stem": "UserManager",
				"path": "docs/UserManager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/UserManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/UserManager.json",
			"path": "/docs/UserManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "UserManagerEmitter.json",
				"ext": "json",
				"name": "UserManagerEmitter",
				"extname": ".json",
				"basename": "UserManagerEmitter.json",
				"dirname": "docs",
				"stem": "UserManagerEmitter",
				"path": "docs/UserManagerEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/UserManagerEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/UserManagerEmitter.json",
			"path": "/docs/UserManagerEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "UserProxy.json",
				"ext": "json",
				"name": "UserProxy",
				"extname": ".json",
				"basename": "UserProxy.json",
				"dirname": "docs",
				"stem": "UserProxy",
				"path": "docs/UserProxy.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/UserProxy.json",
				"isAbsolute": false
			},
			"requirePath": "docs/UserProxy.json",
			"path": "/docs/UserProxy/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "VotingManager.json",
				"ext": "json",
				"name": "VotingManager",
				"extname": ".json",
				"basename": "VotingManager.json",
				"dirname": "docs",
				"stem": "VotingManager",
				"path": "docs/VotingManager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/VotingManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/VotingManager.json",
			"path": "/docs/VotingManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "VotingManagerEmitter.json",
				"ext": "json",
				"name": "VotingManagerEmitter",
				"extname": ".json",
				"basename": "VotingManagerEmitter.json",
				"dirname": "docs",
				"stem": "VotingManagerEmitter",
				"path": "docs/VotingManagerEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/VotingManagerEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/VotingManagerEmitter.json",
			"path": "/docs/VotingManagerEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Wallet.json",
				"ext": "json",
				"name": "Wallet",
				"extname": ".json",
				"basename": "Wallet.json",
				"dirname": "docs",
				"stem": "Wallet",
				"path": "docs/Wallet.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/Wallet.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Wallet.json",
			"path": "/docs/Wallet/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "WalletEmitter.json",
				"ext": "json",
				"name": "WalletEmitter",
				"extname": ".json",
				"basename": "WalletEmitter.json",
				"dirname": "docs",
				"stem": "WalletEmitter",
				"path": "docs/WalletEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/WalletEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/WalletEmitter.json",
			"path": "/docs/WalletEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "WalletsFactory.json",
				"ext": "json",
				"name": "WalletsFactory",
				"extname": ".json",
				"basename": "WalletsFactory.json",
				"dirname": "docs",
				"stem": "WalletsFactory",
				"path": "docs/WalletsFactory.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/WalletsFactory.json",
				"isAbsolute": false
			},
			"requirePath": "docs/WalletsFactory.json",
			"path": "/docs/WalletsFactory/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "WalletsManager.json",
				"ext": "json",
				"name": "WalletsManager",
				"extname": ".json",
				"basename": "WalletsManager.json",
				"dirname": "docs",
				"stem": "WalletsManager",
				"path": "docs/WalletsManager.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/WalletsManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/WalletsManager.json",
			"path": "/docs/WalletsManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "WalletsManagerEmitter.json",
				"ext": "json",
				"name": "WalletsManagerEmitter",
				"extname": ".json",
				"basename": "WalletsManagerEmitter.json",
				"dirname": "docs",
				"stem": "WalletsManagerEmitter",
				"path": "docs/WalletsManagerEmitter.json",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/docs/WalletsManagerEmitter.json",
				"isAbsolute": false
			},
			"requirePath": "docs/WalletsManagerEmitter.json",
			"path": "/docs/WalletsManagerEmitter/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md",
				"absolute": "/Users/alesanro/Documents/Projects/ChronoBank/SmartContracts/scripts/doxity/index.md",
				"isAbsolute": false
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 386
// module chunks = 0